import {
  PathsApiUserAssetsGetParametersQueryAssetSource,
  PathsApiUserAssetsGetParametersQueryAssetType,
} from "@apis/generated/openapi";
import { getUserAssetsV2, type UserAssetV2Record } from "@apis/http/api";
import type { ScrollPageResult } from "@hooks/useScrollLoad";

export const GENERATED_VIDEO_ASSETS_REFRESH_EVENT = "generated-video-assets:refresh";

type JobContextWithCover = { coverImageUrl?: string };

export const getAssetCoverUrl = (record: UserAssetV2Record) => {
  const context = record.jobItem?.context as JobContextWithCover | undefined;
  return record.vidExtra?.coverImageUrl ?? context?.coverImageUrl;
};

export const getAssetPublishMeta = (record: UserAssetV2Record) => record.vidExtra;

export const isProcessingAsset = (record: Pick<UserAssetV2Record, "jobItem">) => {
  return ["processing", "queued"].includes(record.jobItem?.status || "");
};

export const getNewGeneratedCardsCount = (items: UserAssetV2Record[], viewedIds: string[]) => {
  return items.filter((item) => !viewedIds.includes(String(item.id))).length;
};

export const fetchGeneratedVideoAssetsPage = async ({
  pageNo,
  pageSize,
}: {
  pageNo: number;
  pageSize: number;
}): Promise<ScrollPageResult<UserAssetV2Record>> => {
  const response = await getUserAssetsV2({
    assetType: PathsApiUserAssetsGetParametersQueryAssetType.VID,
    assetSource: PathsApiUserAssetsGetParametersQueryAssetSource.AI,
    pageNo,
    pageSize,
  });
  const data = (response?.data ?? []).filter((record) => record.state === undefined || record.state === 1);

  return {
    data,
    pageNo: Number(response?.pageNo ?? pageNo),
    pageSize: Number(response?.pageSize ?? pageSize),
    total: Number(response?.total ?? data.length),
  };
};

export const notifyGeneratedVideoAssetsChanged = () => {
  window.dispatchEvent(new CustomEvent(GENERATED_VIDEO_ASSETS_REFRESH_EVENT));
};
